(function () {
  if (window.CushyBumCartOffer) return;

  var fallbackRules = {
    giftVariants: {
      carryBag: '52936351514934',
      cushyBundle: '52936843559222'
    },
    cartWideGifts: {
      standardBagThreshold: 2,
      eofyBagThreshold: 1,
      bundleThreshold: 3
    },
    offers: [
      {
        id: 'standard-cushy-bum',
        variantIds: ['51849753264438'],
        productHandles: ['inflatable-travel-pillow'],
        handleIncludes: ['cushy-bum'],
        excludeVariantIds: [],
        tiers: [
          { minQuantity: 1, carryBagsPerUnit: 0, cushyBundleQuantity: 0 },
          { minQuantity: 2, carryBagsPerUnit: 1, cushyBundleQuantity: 0 },
          { minQuantity: 3, carryBagsPerUnit: 1, cushyBundleQuantity: 1 }
        ]
      },
      {
        id: 'eofy-cushy-bum',
        variantIds: ['54074976567606'],
        productHandles: [],
        tiers: [
          { minQuantity: 1, carryBagsPerUnit: 1, cushyBundleQuantity: 0 },
          { minQuantity: 3, carryBagsPerUnit: 1, cushyBundleQuantity: 1 }
        ]
      }
    ]
  };
  var mutationQueue = Promise.resolve();
  var syncTimer = null;

  function rules() {
    return window.CushyBumOfferRules || fallbackRules;
  }

  function giftVariants() {
    var giftConfig = rules().giftVariants || {};

    return {
      carryBag: String(giftConfig.carryBag || fallbackRules.giftVariants.carryBag),
      cushyBundle: String(giftConfig.cushyBundle || fallbackRules.giftVariants.cushyBundle)
    };
  }

  function variantId(item) {
    return String(item.variant_id || item.id || '');
  }

  function itemHandle(item) {
    return String(item.handle || item.product_handle || '').toLowerCase();
  }

  function itemUrl(item) {
    return String(item.url || '').toLowerCase();
  }

  function isPaidUpsell(item) {
    return !!(item.properties && item.properties._cb_paid_upsell);
  }

  function isAutoGift(item) {
    if (isPaidUpsell(item)) return false;

    var gifts = giftVariants();
    var id = variantId(item);
    if (id !== gifts.carryBag && id !== gifts.cushyBundle) return false;

    // Require explicit marker so paid carry bags (same variant ID) aren't miscounted as gifts
    return !!(item.properties && item.properties._cb_auto_gift);
  }

  function lineRole(item) {
    if (isPaidUpsell(item)) return 'paid-upsell';
    if (isAutoGift(item)) return 'auto-gift';
    return 'standard';
  }

  function resolveCartLine(cart, descriptor) {
    descriptor = typeof descriptor === 'object' ? descriptor : { key: String(descriptor || '') };

    var items = cart && cart.items ? cart.items : [];
    var key = String(descriptor.key || '');
    var targetVariantId = String(descriptor.variantId || '');
    var role = String(descriptor.role || '');
    var visualLine = Number(descriptor.visualLine || 0);
    var index = -1;

    if (key) {
      index = items.findIndex(function (item) {
        return String(item.key || '') === key;
      });
    }

    if (index < 0 && targetVariantId) {
      index = items.findIndex(function (item) {
        return variantId(item) === targetVariantId && (!role || lineRole(item) === role);
      });
    }

    if (index < 0 && visualLine > 0 && items[visualLine - 1]) {
      index = visualLine - 1;
    }

    if (index < 0) {
      throw new Error('This cart item is no longer available. The cart has been refreshed.');
    }

    return index + 1;
  }

  function getCart() {
    return fetchJson('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (parseError) {
          // The response was not JSON — typically an HTML page such as a
          // Cloudflare/bot "Just a moment..." challenge served on the custom
          // domain. Fail with a clear, friendly message instead of the cryptic
          // "Unexpected token '<'" so the shopper knows to refresh.
          throw new Error('The cart is temporarily unavailable. Please refresh the page and try again.');
        }

        if (!response.ok || data.status || data.errors) {
          var message = data.description || data.message || data.errors || 'Cart request failed';
          throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
        }

        return data;
      });
    });
  }

  function cartAddUrl() {
    var url = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
    return /\.js($|\?)/.test(url) ? url : url + '.js';
  }

  function cartChangeUrl() {
    return window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change.js';
  }

  function cartUpdateUrl() {
    return window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
  }

  // Prefer fresh sections from a POST /cart/update.js response. That response is
  // rendered per-cart and is never served from Shopify's CDN section cache, and it
  // does not depend on the current product URL (which can hang or 404 for handles
  // containing encoded characters like the "™" in this product). sections_url is
  // forced to '/' so the global cart-drawer section always renders.
  function fetchSectionsViaUpdate(sectionIds) {
    return fetchJson(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        sections: sectionIds,
        sections_url: '/'
      })
    }).then(function (cartResponse) {
      if (cartResponse && cartResponse.sections) return cartResponse.sections;
      throw new Error('No sections in cart update response');
    });
  }

  // Fallback: the original path-based GET, but cache-busted and time-boxed so a
  // slow/hanging request can never leave the drawer permanently stale.
  function fetchSectionsViaGet(sectionIds) {
    var url = window.location.pathname +
      '?sections=' + encodeURIComponent(sectionIds.join(',')) +
      '&_cb=' + Date.now();
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, 6000) : null;
    var options = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (controller) options.signal = controller.signal;

    return fetchJson(url, options)
      .then(function (sections) {
        if (timer) window.clearTimeout(timer);
        return sections;
      })
      .catch(function (error) {
        if (timer) window.clearTimeout(timer);
        throw error;
      });
  }

  function attachSections(cart) {
    var sectionIds = getSections();

    return fetchSectionsViaUpdate(sectionIds)
      .then(function (sections) {
        cart.sections = sections;
        return cart;
      })
      .catch(function () {
        return fetchSectionsViaGet(sectionIds)
          .then(function (sections) {
            cart.sections = sections;
            return cart;
          })
          .catch(function () {
            // Both strategies failed (e.g. network throttling). Return the cart
            // without sections; renderCartState() will skip the repaint instead of
            // throwing, and the next successful mutation will refresh the drawer.
            return cart;
          });
      });
  }

  function getCurrency(cart) {
    return (cart && cart.currency) || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'AUD';
  }

  function sortedTiers(offer) {
    return (offer.tiers || []).slice().sort(function (a, b) {
      return Number(a.minQuantity || 0) - Number(b.minQuantity || 0);
    });
  }

  function bestTier(offer, quantity) {
    var match = null;

    sortedTiers(offer).forEach(function (tier) {
      if (quantity >= Number(tier.minQuantity || 0)) {
        match = tier;
      }
    });

    return match;
  }

  function isGiftVariant(item) {
    var gifts = giftVariants();
    var id = variantId(item);
    return id === gifts.carryBag || id === gifts.cushyBundle;
  }

  function offerMatchesByVariant(item, offer) {
    return (offer.variantIds || []).map(String).indexOf(variantId(item)) !== -1;
  }

  function offerMatchesByHandle(item, offer) {
    var handle = itemHandle(item);
    var url = itemUrl(item);

    var byHandleList = (offer.productHandles || []).some(function (productHandle) {
      var normalized = String(productHandle || '').toLowerCase();
      return normalized && (handle === normalized || url.indexOf('/products/' + normalized) !== -1);
    });
    if (byHandleList) return true;

    return (offer.handleIncludes || []).some(function (fragment) {
      var normalized = String(fragment || '').toLowerCase();
      return normalized && (handle.indexOf(normalized) !== -1 || url.indexOf(normalized) !== -1);
    });
  }

  function offerExcludes(item, offer) {
    return (offer.excludeVariantIds || []).map(String).indexOf(variantId(item)) !== -1;
  }

  // Assign each cart item to AT MOST ONE offer so gifts are never double counted.
  // Priority: explicit variant match wins over generic handle match. Gift lines
  // and paid upsells are never counted as Cushy Bums.
  function findOfferForItem(item) {
    if (isPaidUpsell(item)) return null;
    if (isGiftVariant(item)) return null;

    var offers = rules().offers || [];
    var i;

    for (i = 0; i < offers.length; i++) {
      if (!offerExcludes(item, offers[i]) && offerMatchesByVariant(item, offers[i])) {
        return offers[i];
      }
    }

    for (i = 0; i < offers.length; i++) {
      if (!offerExcludes(item, offers[i]) && offerMatchesByHandle(item, offers[i])) {
        return offers[i];
      }
    }

    return null;
  }

  function expectedGifts(cart) {
    var expected = {
      cushyBumQuantity: 0,
      carryBags: 0,
      cushyBundle: 0,
      standardQuantity: 0,
      eofyQuantity: 0,
      offers: []
    };
    var cartWideGifts = rules().cartWideGifts || fallbackRules.cartWideGifts;
    var totalStandardQuantity = 0;
    var totalEofyQuantity = 0;

    // First, assign every cart item to a single offer and tally quantities.
    var quantityByOffer = {};
    (cart.items || []).forEach(function (item) {
      var offer = findOfferForItem(item);
      if (!offer) return;
      quantityByOffer[offer.id] = (quantityByOffer[offer.id] || 0) + (item.quantity || 0);
    });

    (rules().offers || []).forEach(function (offer) {
      var quantity = quantityByOffer[offer.id] || 0;

      if (!quantity) return;

      var tier = bestTier(offer, quantity);
      var carryBags = tier ? quantity * Number(tier.carryBagsPerUnit || 0) : 0;
      var cushyBundle = tier ? Number(tier.cushyBundleQuantity || 0) : 0;

      expected.cushyBumQuantity += quantity;
      if (offer.id === 'eofy-cushy-bum') {
        totalEofyQuantity += quantity;
      } else {
        totalStandardQuantity += quantity;
      }
      expected.offers.push({
        id: offer.id,
        label: offer.label || offer.id,
        quantity: quantity,
        carryBags: carryBags,
        cushyBundle: cushyBundle
      });
    });

    expected.standardQuantity = totalStandardQuantity;
    expected.eofyQuantity = totalEofyQuantity;

    if (expected.cushyBumQuantity >= Number(cartWideGifts.standardBagThreshold || 2)) {
      expected.carryBags = expected.cushyBumQuantity;
    } else if (totalEofyQuantity >= Number(cartWideGifts.eofyBagThreshold || 1)) {
      expected.carryBags = totalEofyQuantity;
    }

    if (expected.cushyBumQuantity >= Number(cartWideGifts.bundleThreshold || 3)) {
      expected.cushyBundle = 1;
    }

    return expected;
  }

  function giftLineSummary(cart, targetVariantId) {
    var summary = {
      quantity: 0,
      lines: []
    };

    (cart.items || []).forEach(function (item) {
      if (variantId(item) !== targetVariantId || !isAutoGift(item)) return;

      summary.quantity += item.quantity || 0;
      summary.lines.push(item);
    });

    return summary;
  }

  function updateCartLines(updates) {
    if (!Object.keys(updates || {}).length) return Promise.resolve(null);

    return fetchJson(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    });
  }

  function addGiftItems(items) {
    if (!items.length) return Promise.resolve(null);

    return fetchJson(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    });
  }

  function lineUpdatesForGift(cart, targetVariantId, expectedQuantity) {
    var summary = giftLineSummary(cart, targetVariantId);

    if (summary.quantity <= expectedQuantity) return {};

    var quantityToRemove = summary.quantity - expectedQuantity;
    var updates = {};

    summary.lines.forEach(function (line) {
      if (!quantityToRemove) return;

      var lineQuantity = line.quantity || 0;
      var nextQuantity = lineQuantity;

      if (quantityToRemove >= lineQuantity) {
        nextQuantity = 0;
        quantityToRemove -= lineQuantity;
      } else {
        nextQuantity = lineQuantity - quantityToRemove;
        quantityToRemove = 0;
      }

      updates[line.key] = Math.max(0, nextQuantity);
    });

    return updates;
  }

  function missingGiftItems(cart, targetVariantId, expectedQuantity) {
    var summary = giftLineSummary(cart, targetVariantId);
    var missingQuantity = expectedQuantity - summary.quantity;

    if (missingQuantity <= 0) return [];

    return [
      {
        id: String(targetVariantId),
        quantity: missingQuantity,
        properties: {
          _cb_auto_gift: 'true'
        }
      }
    ];
  }

  function buildGiftPlan(cart) {
    var expected = expectedGifts(cart);
    var gifts = giftVariants();
    var updates = Object.assign(
      {},
      lineUpdatesForGift(cart, gifts.carryBag, expected.carryBags),
      lineUpdatesForGift(cart, gifts.cushyBundle, expected.cushyBundle)
    );
    var additions = missingGiftItems(cart, gifts.carryBag, expected.carryBags).concat(
      missingGiftItems(cart, gifts.cushyBundle, expected.cushyBundle)
    );

    return {
      expected: expected,
      additions: additions,
      updates: updates,
      hasChanges: additions.length > 0 || Object.keys(updates).length > 0
    };
  }

  function applyGiftPlan(cart) {
    var plan = buildGiftPlan(cart);
    var work = Promise.resolve(cart);

    if (Object.keys(plan.updates).length) {
      work = work.then(function () {
        return updateCartLines(plan.updates);
      });
    }

    if (plan.additions.length) {
      work = work.then(function () {
        return addGiftItems(plan.additions);
      });
    }

    if (!plan.hasChanges) return work;

    return work.then(getCart);
  }

  function offerVariantIds() {
    var ids = [];

    (rules().offers || []).forEach(function (offer) {
      (offer.variantIds || []).forEach(function (id) {
        ids.push(String(id));
      });
    });

    return ids;
  }

  function currentProductHandle() {
    var path = String(window.location.pathname || '').toLowerCase();
    var match = path.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  function handleMatchesAnyOffer(handle) {
    handle = String(handle || '').toLowerCase();
    if (!handle) return false;

    return (rules().offers || []).some(function (offer) {
      var byList = (offer.productHandles || []).some(function (productHandle) {
        return String(productHandle || '').toLowerCase() === handle;
      });
      if (byList) return true;

      return (offer.handleIncludes || []).some(function (fragment) {
        var normalized = String(fragment || '').toLowerCase();
        return normalized && handle.indexOf(normalized) !== -1;
      });
    });
  }

  function formHasCushyBum(form) {
    if (!form) return false;

    var ids = offerVariantIds();
    var idInput = form.querySelector('[name="id"]');

    if (idInput && ids.indexOf(String(idInput.value)) !== -1) return true;

    // Fall back to the current product handle so duplicated Cushy Bum products
    // (which have different variant IDs) are still recognised on their own page.
    return handleMatchesAnyOffer(currentProductHandle());
  }

  function quantityFromForm(form) {
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (isNaN(quantity) || quantity < 1) quantity = 1;

    return quantity;
  }

  function formProperties(form) {
    var properties = {};
    if (!form) return properties;

    Array.prototype.slice.call(form.querySelectorAll('[name^="properties["]')).forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (!match || input.disabled) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      properties[match[1]] = input.value;
    });

    return properties;
  }

  function cartAddPayloadForForm(form) {
    if (!formHasCushyBum(form)) return null;

    var idInput = form.querySelector('[name="id"]');
    var variantIdToAdd = idInput ? String(idInput.value || '') : '';
    if (!variantIdToAdd || variantIdToAdd.indexOf(',') !== -1) return null;

    var quantity = quantityFromForm(form);
    var handle = currentProductHandle();
    var expected = expectedGifts({
      items: [
        {
          variant_id: variantIdToAdd,
          id: variantIdToAdd,
          quantity: quantity,
          properties: {},
          handle: handle,
          url: handle ? '/products/' + handle : ''
        }
      ]
    });
    var gifts = giftVariants();
    var productItem = {
      id: variantIdToAdd,
      quantity: quantity
    };
    var sellingPlan = form.querySelector('[name="selling_plan"]');
    var productProperties = formProperties(form);
    var payload = {
      items: [productItem]
    };

    if (sellingPlan && sellingPlan.value) {
      productItem.selling_plan = sellingPlan.value;
    }
    if (Object.keys(productProperties).length) {
      productItem.properties = productProperties;
    }
    if (expected.carryBags > 0) {
      payload.items.push({
        id: gifts.carryBag,
        quantity: expected.carryBags,
        properties: {
          _cb_auto_gift: 'true'
        }
      });
    }
    if (expected.cushyBundle > 0) {
      payload.items.push({
        id: gifts.cushyBundle,
        quantity: expected.cushyBundle,
        properties: {
          _cb_auto_gift: 'true'
        }
      });
    }
    return payload;
  }

  function trackCartEvent(eventName, payload) {
    var eventPayload = Object.assign(
      {
        event: eventName,
        source: 'native_cart_drawer',
        timestamp: new Date().toISOString()
      },
      payload || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    window.dispatchEvent(new CustomEvent(eventName, { detail: eventPayload }));

    try {
      var stored = JSON.parse(window.sessionStorage.getItem('cbCartAnalytics') || '{"upsellClicks":0,"upsellAdds":0,"upsellValueCents":0}');

      if (eventName === 'cushy_bum_cart_upsell_clicked') {
        stored.upsellClicks += 1;
      }
      if (eventName === 'cushy_bum_cart_upsell_added') {
        stored.upsellAdds += 1;
        stored.upsellValueCents += Number(eventPayload.value_cents || 0);
      }

      window.sessionStorage.setItem('cbCartAnalytics', JSON.stringify(stored));
    } catch (error) {
      console.warn('Cushy Bum cart analytics storage failed', error);
    }
  }

  function getSections() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (section) {
        return section.section || section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function renderCartState(parsedState, openDrawer) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !parsedState || !parsedState.sections || typeof cartDrawer.renderContents !== 'function') {
      return parsedState;
    }

    var shouldRemainOpen = openDrawer !== false || cartDrawer.classList.contains('active');
    cartDrawer.renderContents(parsedState);

    // NOTE: cart prices are rendered server-side in the visitor's market currency
    // (Shopify Markets), so the drawer is already correct after renderContents.
    // We intentionally do NOT call bucksCC.reConvert() here — it throws in this
    // store's Markets context and is unnecessary.

    if (!shouldRemainOpen) {
      window.setTimeout(function () {
        cartDrawer.close();
      }, 0);
    }

    return parsedState;
  }

  // Single round trip that applies any gift quantity updates AND returns the
  // FINAL cart + rendered sections — /cart/update.js accepts `updates` and
  // `sections` together, so a reduce/remove is one request instead of two.
  function fetchCartAndSections(updates) {
    var sectionIds = getSections();
    var body = { sections: sectionIds, sections_url: '/' };
    if (updates && Object.keys(updates).length) body.updates = updates;

    return fetchJson(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (cart) {
        if (cart && cart.sections) return cart;
        throw new Error('No sections in cart update response');
      })
      .catch(function () {
        // Fallback if the combined POST is blocked/slow: apply updates, then
        // fetch cart + cache-busted GET sections.
        var pre = (updates && Object.keys(updates).length) ? updateCartLines(updates) : Promise.resolve();
        return pre.then(getCart).then(function (cart) {
          return fetchSectionsViaGet(sectionIds)
            .then(function (sections) { cart.sections = sections; return cart; })
            .catch(function () { return cart; });
        });
      });
  }

  function reconcileCart(mutation, options) {
    options = options || {};
    document.documentElement.classList.add('cb-cart-syncing');

    return Promise.resolve()
      .then(function () {
        return typeof mutation === 'function' ? mutation() : null;
      })
      .then(function (mutationResult) {
        // Reuse the full cart a mutation already returned (e.g. /cart/change.js)
        // instead of spending an extra /cart.js round trip.
        if (mutationResult && typeof mutationResult.item_count === 'number' && Array.isArray(mutationResult.items)) {
          return mutationResult;
        }
        return getCart();
      })
      .then(function (cart) {
        var plan = buildGiftPlan(cart);
        // `updates` cap gift lines at the expected amount (e.g. revert a manual
        // gift increase, or trim gifts when cushions are reduced) — always apply.
        // `additions` top gifts back up to the expected amount. We SKIP additions
        // when the shopper is directly editing a gift line, so they can keep
        // fewer free gifts than the max without it snapping back.
        var additions = options.noGiftAdditions ? [] : plan.additions;
        var work = Promise.resolve();
        if (additions.length) {
          work = work.then(function () { return addGiftItems(additions); });
        }
        // Fold the gift `updates` into the same call that fetches the sections.
        return work.then(function () { return fetchCartAndSections(plan.updates); });
      })
      .then(function (state) {
        if (options.render !== false) {
          renderCartState(state, options.openDrawer);
        }
        document.documentElement.classList.remove('cb-cart-syncing');
        // Fire the standard Shopify cart-update event so Meta Pixel, IntelliGems,
        // and any app listening to PUB_SUB_EVENTS.cartUpdate see every cart change.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cushy-bum-cart-offer' });
        }
        return state;
      })
      .catch(function (error) {
        document.documentElement.classList.remove('cb-cart-syncing');
        console.error('Cushy Bum cart update failed', error);
        throw error;
      });
  }

  function enqueueCartMutation(mutation, options) {
    var operation = mutationQueue
      .catch(function () {
        return null;
      })
      .then(function () {
        return reconcileCart(mutation, options);
      });

    mutationQueue = operation.catch(function () {
      return null;
    });

    return operation;
  }

  function updateGifts(options) {
    return enqueueCartMutation(null, Object.assign({ render: false }, options || {}));
  }

  function scheduleSync(options) {
    options = Object.assign(
      {
        openDrawer: true,
        delay: 120
      },
      options || {}
    );

    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncAndRender(options).catch(function () {
        return null;
      });
    }, options.delay);
  }

  function syncAndRender(options) {
    return enqueueCartMutation(null, Object.assign({
      render: true,
      openDrawer: true
    }, options || {}));
  }

  function changeLineAndRender(descriptor, quantity, options) {
    if (!descriptor) return Promise.reject(new Error('Missing cart line'));

    return enqueueCartMutation(function () {
      var qty = Math.max(0, Number(quantity) || 0);
      var key = (typeof descriptor === 'object' && descriptor.key) ? String(descriptor.key) : '';

      // Resolve the line from a fresh cart (handles stale/missing keys, e.g.
      // rapid clicks where the key changed between renders).
      function changeByResolvedLine() {
        return getCart().then(function (cart) {
          return fetchJson(cartChangeUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              line: resolveCartLine(cart, descriptor),
              quantity: qty
            })
          });
        });
      }

      // Fast path: change by line key directly (no /cart.js lookup needed).
      // If the key is stale, fall back to resolving the line.
      if (key) {
        return fetchJson(cartChangeUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: qty })
        }).catch(function () {
          return changeByResolvedLine();
        });
      }

      return changeByResolvedLine();
    }, Object.assign({
      render: true,
      openDrawer: true,
      // When the shopper edits a gift line directly (reduce/remove a free bag or
      // bundle), don't auto-restore it — let them keep fewer than the max.
      noGiftAdditions: !!(typeof descriptor === 'object' && descriptor.role === 'auto-gift')
    }, options || {}));
  }

  function addItemsAndRender(items, options) {
    if (!items || !items.length) return Promise.reject(new Error('Missing cart items'));

    return enqueueCartMutation(function () {
      return fetchJson(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });
    }, Object.assign({
      render: true,
      openDrawer: true
    }, options || {}));
  }

  function showDrawerError(error) {
    var errorTarget = document.getElementById('CartDrawer-CartErrors');
    if (errorTarget) {
      errorTarget.textContent = error && error.message ? error.message : 'There was an error updating your cart.';
    }
  }

  function setButtonBusy(button, isBusy) {
    if (!button) return;

    button.toggleAttribute('aria-busy', isBusy);
    button.classList.toggle('is-loading', isBusy);
  }

  function paidUpsellItem(variantIdToAdd) {
    return {
      id: String(variantIdToAdd),
      quantity: 1,
      properties: {
        _cb_paid_upsell: 'true'
      }
    };
  }

  function cushyBumItem(variantIdToAdd) {
    return {
      id: String(variantIdToAdd),
      quantity: 1
    };
  }

  function trackAddedUpsell(variantIdToAdd, upsellTitle, upsellValueCents, state) {
    trackCartEvent('cushy_bum_cart_upsell_added', {
      variant_id: String(variantIdToAdd),
      product_title: upsellTitle,
      value_cents: upsellValueCents,
      currency: getCurrency(state)
    });
  }

  function addPaidUpsell(variantIdToAdd, button) {
    if (!variantIdToAdd) return Promise.resolve(null);

    var upsellTitle = button ? button.getAttribute('data-product-title') : '';
    var upsellValueCents = button ? Number(button.getAttribute('data-price-cents') || 0) : 0;

    trackCartEvent('cushy_bum_cart_upsell_clicked', {
      variant_id: String(variantIdToAdd),
      product_title: upsellTitle,
      value_cents: upsellValueCents
    });

    setButtonBusy(button, true);

    return addItemsAndRender([paidUpsellItem(variantIdToAdd)])
      .then(function (state) {
        trackAddedUpsell(variantIdToAdd, upsellTitle, upsellValueCents, state);
        flashUpsellAdded(variantIdToAdd);
        return state;
      })
      .catch(function (error) {
        console.error('Cushy Bum upsell add failed', error);
        showDrawerError(error);
        return null;
      })
      .finally(function () {
        setButtonBusy(button, false);
      });
  }

  // The drawer re-render replaces the add-on buttons, so briefly confirm success
  // on the freshly rendered button matching this variant.
  function flashUpsellAdded(variantIdToAdd) {
    window.setTimeout(function () {
      var freshButton = document.querySelector(
        '[data-cb-cart-upsell-add][data-variant-id="' + String(variantIdToAdd) + '"]'
      );
      if (!freshButton) return;

      var originalLabel = freshButton.textContent;
      freshButton.classList.add('is-added');
      freshButton.textContent = 'Added ✓';

      window.setTimeout(function () {
        freshButton.classList.remove('is-added');
        freshButton.textContent = originalLabel;
      }, 1100);
    }, 0);
  }

  function addCushyBumFromDrawer(variantIdToAdd, button) {
    if (!variantIdToAdd) return Promise.resolve(null);

    var productTitle = button ? button.getAttribute('data-product-title') : 'Cushy Bum';
    var valueCents = button ? Number(button.getAttribute('data-price-cents') || 0) : 0;

    trackCartEvent('cushy_bum_empty_cart_readd_clicked', {
      variant_id: String(variantIdToAdd),
      product_title: productTitle,
      value_cents: valueCents
    });

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding';
    }

    return addItemsAndRender([cushyBumItem(variantIdToAdd)])
      .then(function (state) {
        trackCartEvent('cushy_bum_empty_cart_readded', {
          variant_id: String(variantIdToAdd),
          product_title: productTitle,
          value_cents: valueCents,
          currency: getCurrency(state)
        });
        return state;
      })
      .catch(function (error) {
        console.error('Cushy Bum re-add failed', error);
        showDrawerError(error);
        return null;
      })
      .finally(function () {
        if (!button) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add';
      });
  }

  window.CushyBumCartOffer = {
    CUSHY_BUM_VARIANT_ID: '51849753264438',
    CUSHY_BUM_EOFY_VARIANT_ID: '54074976567606',
    CARRY_BAG_VARIANT_ID: giftVariants().carryBag,
    CUSHY_BUNDLE_VARIANT_ID: giftVariants().cushyBundle,
    buildGiftPlan: buildGiftPlan,
    expectedGifts: expectedGifts,
    resolveCartLine: resolveCartLine,
    formHasCushyBum: formHasCushyBum,
    cartAddPayloadForForm: cartAddPayloadForForm,
    sync: updateGifts,
    scheduleSync: scheduleSync,
    syncAndRender: syncAndRender,
    changeLineAndRender: changeLineAndRender,
    addItemsAndRender: addItemsAndRender,
    addPaidUpsell: addPaidUpsell,
    addCushyBumFromDrawer: addCushyBumFromDrawer
  };

  document.addEventListener('click', function (event) {
    var cushionButton = event.target.closest('[data-cb-cart-cushion-add]');
    if (cushionButton) {
      event.preventDefault();
      addCushyBumFromDrawer(cushionButton.getAttribute('data-variant-id'), cushionButton);
      return;
    }

    var button = event.target.closest('[data-cb-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();
    addPaidUpsell(button.getAttribute('data-variant-id'), button);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cushy-bum-cart-offer') return;
      scheduleSync({ openDrawer: false, delay: 150 });
    });
  }
})();
